<template>
  <div class="pcontent">
    <div class="p_title">
      <div class="pchooseLocal" @click="getLocal">
        <img
          class="local"
          :src="require('../../../assets/images/localtion.png')"
          alt="位置"
        />
        <span class="areaName">{{ params.AreaLabel }}</span>
      </div>
      <img
        class="sj-img"
        :src="require('../../../assets/images/pLevelPool.png')"
        alt="省级师资库"
      />
      <span class="more" v-if="ismore" @click="getMore">更多>></span>
      <span v-if="!ismore"></span>
    </div>
    <div class="sk_type">
      授课类别：
      <div
        @click="currentCourse(item, index)"
        class="course"
        :class="activeCourse === index ? 'courseBg_active' : 'courseBg'"
        v-for="(item, index) in courseList"
        :key="item"
      >
        {{ item.label }}
      </div>
    </div>
    <template v-if="teacherList.length > 0">
      <div class="people_list">
        <div
          class="teach_item"
          v-for="(item, index) in teacherList"
          :key="index"
        >
          <PeoIntroduce :introduce="item" />
        </div>
      </div>
    </template>
    <div class="empty" v-if="teacherList.length <= 0 && !ismore">暂无数据</div>
    <div v-if="!ismore && teacherList.length > 0" class="pagemore">
      <Page
        :total="total"
        show-elevator
        show-total
        :model-value="params.pageCurrent"
        :page-size="params.MaxResultCount"
        @on-prev="prev"
        @on-next="next"
        @on-change="pageChange"
      />
    </div>
  </div>
  <Modal v-model="localShow" footer-hide class-name="lmodel">
    <div class="local_model">
      <div
        class="local_item"
        :class="currentLocal == index ? 'redbg' : ''"
        v-for="(item, index) in provincelocalList"
        @click="getCurrentLocal(item, index)"
        :key="index"
      >
        {{ item.label }}
      </div>
    </div>
  </Modal>
</template>

<script setup>
import PeoIntroduce from "./peoIntroduce.vue";
import { setDict, getCode } from "../../../utils/dict";
import { useRouter, useRoute } from "vue-router";
import { szkGet } from "../../../api/common.js";
import { onMounted, ref, defineEmits, watch } from "vue";
import { useStore } from "../../../store/index.js";
const store = useStore();
const router = useRouter();
const route = useRoute();
const props = defineProps({
  ismore: {
    type: Boolean,
    default: true,
  },
});

const courseList = ref([]);
const provincelocalList = ref([]); // 省级位置信息
const activeCourse = ref(0);
function currentCourse(item, index) {
  activeCourse.value = index;
  params.value.TeacherType = item.value;
  params.value.SkipCount = 0;
  params.value.pageCurrent = 1;
  store.changeTeacherType(item.value);
  getTeacherList();
}
const teacherList = ref([]);
const params = ref({
  AreaName: "510000",
  AreaLabel: "四川省",
  TeacherType: "",
  MaxResultCount: 6,
  SkipCount: 0,
  TeacherClass: "1",
  pageCurrent: 1,
});
const total = ref(0);
function getTeacherList() {
  szkGet(params.value, "/services/app/TeacherLibaryService/IndexPageList").then(
    (res) => {
      if (res.items && res.items.length) {
        res.items.forEach((item) => {
          item.typeList = [];
          let list = item.lectureCategory
            ? item.lectureCategory.split(",")
            : [];
          list.forEach((ele) => {
            courseList.value.forEach((c) => {
              if (ele == c.value) {
                item.typeList.push(c.label);
              }
            });
          });
        });
      }
      teacherList.value = res.items;
      total.value = res.totalCount;
    }
  );
}
// 点击更多
function getMore() {
  let routeUrl = router.resolve({
    path: "/more",
    query: {
      code: currentLocal.value,
      label: params.value.AreaLabel,
      name: params.value.AreaName,
    },
  });
  window.open(routeUrl.href, "_blank");
}
// 位置弹框
const localShow = ref(false);
const currentLocal = ref(0);
function getLocal() {
  localShow.value = true;
}
// 点击位置
function getCurrentLocal(item, index) {
  currentLocal.value = index;
  params.value.AreaName = item.value;
  params.value.AreaLabel = item.label;
  getTeacherList();
  localShow.value = false;
}
watch(
  () => props.ismore,
  (val) => {
    if (!val) {
      currentLocal.value = route.query.code ? route.query.code : 0;
      params.value.AreaLabel = route.query.label;
      params.value.AreaName = route.query.name;
      getTeacherList();
    }
  },
  {
    deep: true,
    immediate: true,
  }
);
onMounted(async () => {
  if (window.localStorage.getItem("code")) {
    let data = JSON.parse(window.localStorage.getItem("code"));
    provincelocalList.value = [
      {
        label: "四川省",
        value: "510000",
      },
      ...data["AdminArea"][0].children,
    ];
    courseList.value = [
      { label: "全部", value: "" },
      ...data["LectureCategory"],
    ];
    console.log("education333::", provincelocalList.value);
  }
  getTeacherList();
});
function prev(val) {
  params.value.pageCurrent = val;
  params.value.SkipCount = (val - 1) * params.value.MaxResultCount;
  getTeacherList();
}
function next(val) {
  params.value.pageCurrent = val;
  params.value.SkipCount = (val - 1) * params.value.MaxResultCount;
  getTeacherList();
}
function pageChange(val) {
  params.value.pageCurrent = val;
  params.value.SkipCount = (val - 1) * params.value.MaxResultCount;
  getTeacherList();
}
</script>

<style lang="scss" scoped>
.pcontent {
  margin: 21px auto;
  width: 1190px;
  background-color: #ededed;
  box-shadow: 0px 0px 10px 0px #ededed;
  padding: 26px;
  color: #000;
  .more {
    color: #eb0100;
    cursor: pointer;
    margin-bottom: 5px;
  }
  .p_title {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    border-bottom: 1px solid #ebc9c1;
  }
  .pchooseLocal {
    cursor: pointer;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .local {
      cursor: pointer;
      width: 23px;
      height: 34px;
    }
    .areaName {
      display: inline-block;
      margin-left: 10px;
    }
  }
  .sj-img {
    width: 302px;
    height: 59px;
  }

  .sk_type {
    display: flex;
    margin: 20px 0px;
    align-items: center;
    .course {
      margin: 0 15px;
      cursor: pointer;
    }
    .courseBg {
      width: 125px;
      height: 34px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: url(../../../assets/images/choose.png) no-repeat center center;
      background-size: 100% 100%;
    }
    .courseBg_active {
      width: 125px;
      height: 34px;
      vertical-align: baseline;
      background: url(../../../assets/images/choosed.png) no-repeat center
        center;
      background-size: 100% 100%;
      color: #fff;
    }
  }
  .people_list {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .teach_item {
      margin-top: 20px;
    }
  }
}
.pagemore {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}
.local_model {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  .local_item {
    width: 20%;
    line-height: calc(228px / 5);
    text-align: center;
    cursor: pointer;
    border-bottom: 1px solid #ebc9c1;
  }
  :last-child {
    border-bottom: 1px solid rgba(0, 0, 0, 0);
  }
  :nth-child(21) {
    border-bottom: 1px solid rgba(0, 0, 0, 0);
  }
  .redbg {
    background-color: #d00303;
    color: #fff;
  }
}
</style>
<style>
.lmodel .ivu-modal {
  width: 648px !important;
  height: 274px !important;
}
.lmodel .ivu-modal-body {
  width: 648px !important;
  height: 274px !important;
  background: url("../../../assets/images/local.png") no-repeat center center !important;
  background-size: 100% 100% !important;
  padding: 40px 2px 0px !important;
}
.lmodel .ivu-modal-content {
  background-color: transparent !important;
}
</style>
